<template>
  <transition name="fade-arrow">
    <div v-if="isCanScrollAnswerList" :class="style.arrowWrapper" ref="arrows">
      <div :class="style.arrows"></div>
    </div>
  </transition>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./arrowAnimationComponent.module.scss";

export default defineComponent({
  name: "AnimationArrowComponent",
  props: {
    isCanScrollAnswerList: Boolean
  },
  data() {
    return {
      style,
      opacityArrow: 1
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.opacityArrow = 0;
    // }, 5000);
  },
  watch: {
    questionsListCont() {
      this.opacityArrow = 1;
      setTimeout(() => {
        this.opacityArrow = 0;
      }, 5000);
    }
  }
});
</script>
